import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class Bin {
  create = async (bin: any) => {
    await axios.post<any>(`${API_URL}item-bin`, bin)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  edit = async (bin: any, code: any) => {
    await axios.put<any>(`${API_URL}item-bin/${code}`, bin)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}item-bin/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.bin;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}item-bin`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.bin;
  };
}

export default new Bin();
